/**
 * @enum {typeof EnumTiposStatusVolume[keyof typeof EnumTiposStatusVolume]}
 */
export const EnumTiposStatusVolume = Object.freeze({
    Regular: 0,
    ExplodidoMaster: 1,
    ExplodidoFilhote: 2,
    ConsolidadoMaster: 3,
    ConsolidadoFilhote: 4,
    PrevisaoMaster: 5,
    Master: 6,
    Etiqueta: 7,
    EtiquetaSemLote: 8
});
